import { useNavigate, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

interface AlphabeticalIndexProps {
  variant?: "horizontal" | "grid";
  className?: string;
}

export function AlphabeticalIndex({
  variant = "horizontal",
  className,
}: AlphabeticalIndexProps) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeLetter = searchParams.get("letter")?.toUpperCase();

  const handleLetterClick = (letter: string) => {
    navigate(`/browse?letter=${letter}`);
  };

  return (
    <div className={className}>
      <h3 className="text-muted-foreground mb-4 text-sm font-semibold uppercase tracking-wider">
        {t("alphabetical.title")}
      </h3>
      <div
        className={cn(
          "gap-2",
          variant === "horizontal"
            ? "flex flex-wrap justify-center sm:justify-start"
            : "grid grid-cols-4 gap-2 sm:grid-cols-7 md:grid-cols-9 lg:grid-cols-[repeat(13,minmax(0,1fr))]"
        )}
      >
        {alphabet.map(letter => (
          <button
            key={letter}
            onClick={() => handleLetterClick(letter)}
            className={cn(
              "flex h-9 w-9 items-center justify-center rounded-lg text-sm font-semibold transition-all duration-200 sm:h-10 sm:w-10",
              "hover:bg-primary hover:scale-110 hover:text-white hover:shadow-lg",
              "focus:ring-primary/50 focus:outline-none focus:ring-2",
              activeLetter === letter
                ? "bg-primary scale-105 text-white shadow-lg"
                : "text-foreground border-border/50 hover:border-primary/50 border bg-white"
            )}
          >
            {letter}
          </button>
        ))}
      </div>
    </div>
  );
}
